// Both `changePassword` and `deleteAccount` re-verify the caller's own current password
// server-side (see accountService.verifyOwnPassword) -- a 401 from either one means "that
// password was wrong," not "this session is no longer valid," so both opt out of http.js's
// default unauthorized handling (which would otherwise clear the whole app's auth state on
// a simple typo). Every other call here keeps the default: a 401 from any of them really
// does mean the session is gone.
const SKIP_UNAUTHORIZED_HANDLER = { skipUnauthorizedHandler: true }

export function createAuthApi(http) {
  return {
    signup: (body) => http.post('/api/auth/signup', body),
    login: (body) => http.post('/api/auth/login', body),
    logout: () => http.post('/api/auth/logout'),
    forgotPassword: (body) => http.post('/api/auth/forgot-password', body),
    // A 401 here means "that reset link is no good", never "your session expired" -- the
    // caller is by definition signed out -- so it must not trip the app-wide unauthorized
    // handler, same reasoning as changePassword above.
    resetPassword: (body) => http.post('/api/auth/reset-password', body, SKIP_UNAUTHORIZED_HANDLER),
    me: () => http.get('/api/auth/me'),
    updateProfile: (body) => http.patch('/api/auth/me', body),
    changePassword: (body) => http.patch('/api/auth/password', body, SKIP_UNAUTHORIZED_HANDLER),
    deleteAccount: ({ password }) => http.del('/api/auth/me', { password }, SKIP_UNAUTHORIZED_HANDLER),
  }
}
